import { render, staticRenderFns } from "./MwEditor.vue?vue&type=template&id=15385672&"
import script from "./MwEditor.vue?vue&type=script&lang=js&"
export * from "./MwEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports